import React from 'react';
import T from 'prop-types';
// redux
import { connect } from 'react-redux';
import { openModal } from 'reducers/modals';
// components
import { FormattedMessage } from 'react-intl';
import Button from 'components/Button';
import ConfirmationModal from 'components/ConfirmationModal/ConfirmationModal';
import { FeedOrderStatusBadge } from 'components/StatusBadge/StatusBadge';
// utils
import classnames from 'classnames/bind';
import { withRouter } from 'react-router';
import { OFFLINE_FEED_ORDER_STATUSES, getRetryFeedOrderPath } from 'utils/offlineFeedOrdersHelper';
// styles
import styles from './PendingFeedOrderCell.module.scss';

const cn = classnames.bind(styles);

// Created cell of an order placed offline: it gets a created date only once the server receives it.
// Until then the user can delete it; an order the server rejected can also be fixed and resent.
// showBadge: the list hides its Status column for tenants without FAS export, so the badge is shown here
const PendingFeedOrderCell = ({ order, onDelete, openModal, router, showBadge }) => {
  const isFailed = order.status === OFFLINE_FEED_ORDER_STATUSES.failed;

  const handleDelete = () => {
    openModal(
      <ConfirmationModal
        title={<FormattedMessage id="general.feedOrder" />}
        warningMessage={<FormattedMessage id="component.pendingFeedOrderStatus.deleteWarning" />}
        actionBtnLabel={<FormattedMessage id="general.button.delete" />}
        actionBtnProps={{ red: true }}
        handleConfirm={() => onDelete(order.client_uuid)}
      />
    );
  };

  const handleEdit = () => router.push(getRetryFeedOrderPath(order));

  return (
    <div className={cn('pending-feed-order-cell')}>
      {showBadge && <FeedOrderStatusBadge status={order.status} />}
      <FormattedMessage id="component.pendingFeedOrderStatus.notSubmitted" />
      {isFailed && (
        <div className={cn('error')}>
          {order.error_key === 'pastDate'
            ? <FormattedMessage id="component.pendingFeedOrderStatus.pastDate" />
            : order.error}
        </div>
      )}
      <div className={cn('actions')}>
        {isFailed && (
          <Button small primary onClick={handleEdit}>
            <FormattedMessage id="general.button.edit" />
          </Button>
        )}
        <Button small red onClick={handleDelete}>
          <FormattedMessage id="general.button.delete" />
        </Button>
      </div>
    </div>
  );
};

PendingFeedOrderCell.propTypes = {
  order: T.shape({
    client_uuid: T.string.isRequired,
    status: T.string.isRequired,
    error: T.string,
    error_key: T.string,
    farm: T.shape({ id: T.number.isRequired }).isRequired,
    pig_group: T.shape({ id: T.number.isRequired }).isRequired,
  }).isRequired,
  onDelete: T.func.isRequired,
  openModal: T.func.isRequired,
  router: T.object.isRequired,
  showBadge: T.bool,
};

PendingFeedOrderCell.defaultProps = {
  showBadge: false,
};

export default withRouter(connect(null, { openModal })(PendingFeedOrderCell));
